<li class="gw-qa-item">
    <div class="gw-qa-item__author-block">
        <slot name="author" />
        <slot name="verified-buyer" />
    </div>
    <div class="gw-qa-item__body">
        <div class="gw-qa-item__text-block">
            <slot name="header" />
            <slot name="text" />
        </div>

        <div class="gw-qa-item__date-block">
            <slot name="date" />
        </div>
        <slot name="reply" />
    </div>
</li>

<style lang="postcss">
    .gw-qa-item {
        display: flex;
        gap: 2em;

        &__body {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            flex: 2;
            border: none;
        }

        &__text-block {
            margin-top: 0.145em;
        }

        &__author-block {
            display: flex;
            flex-direction: column;
            column-gap: 0.5em;

            flex: 0.25;
        }

        &__date-block {
            display: flex;
            justify-content: flex-end;
        }

        &:not(:last-child) {
            padding-bottom: 1.875em;
            border-bottom: 1px solid #e4e7ec;
        }
    }
</style>
